/** 手机触控：独立操作按钮使用至少44px点击区域；桌面保持原紧凑布局，业务权限、提交与跳转逻辑不变。 */
import React from "react";
import { WifiOff, RefreshCw, CloudUpload } from "lucide-react";
import { fmtDT } from "./tmConst";

/* 离线 / 待同步横幅：断网时显示缓存时间；联网但队列非空时显示同步状态 */
export function TMOfflineBanner({ zh, offline, onSync }) {
  if (!offline?.on && !offline?.queue) return null;
  const off = offline.on;
  return (
    <div data-testid="tm-offline-banner" data-offline={off} data-queue={offline.queue || 0}
      className={`mx-3 md:mx-0 mt-3 md:mt-0 rounded-xl border px-3 py-2 text-xs flex items-center gap-2 ${off ? "border-amber-300 bg-amber-50 text-amber-900" : "border-sky-200 bg-sky-50 text-sky-900"}`}>
      {off ? <WifiOff className="h-4 w-4 shrink-0" /> : <CloudUpload className={`h-4 w-4 shrink-0 ${offline.syncing ? "animate-pulse" : ""}`} />}
      <span className="flex-1">
        {off ? (zh ? `离线模式 · 显示${offline.cacheAt ? ` ${fmtDT(offline.cacheAt)} ` : ""}缓存清单，结果将先保存在本机` : `Offline · cached list${offline.cacheAt ? ` from ${fmtDT(offline.cacheAt)}` : ""}; outcomes are saved locally`)
          : (zh ? (offline.syncing ? "正在同步离线结果…" : "已恢复联网") : offline.syncing ? "Syncing offline outcomes…" : "Back online")}
        {offline.queue ? <b className="ml-1" data-testid="tm-offline-queue">{zh ? `待同步 ${offline.queue} 条` : `${offline.queue} queued`}</b> : null}
      </span>
      {!off && offline.queue > 0 && !offline.syncing && <button type="button" onClick={onSync} data-testid="tm-offline-sync" className="min-h-11 min-w-11 md:min-h-0 md:min-w-0 inline-flex items-center gap-1 rounded-full border border-sky-300 px-2 py-0.5 font-medium hover:bg-white"><RefreshCw className="h-3 w-3" />{zh ? "立即同步" : "Sync now"}</button>}
    </div>
  );
}
